import { motion } from 'framer-motion';
import { Calendar, Award, Building2, Lightbulb } from 'lucide-react';

export function Timeline() {
  const milestones = [
    {
      year: '2014',
      title: '公司成立',
      description: '越亘科技正式成立，开启数字化服务之旅',
      icon: Building2,
      color: 'from-orange-600 to-yellow-400',
    },
    {
      year: '2019',
      title: '科技型企业认证',
      description: '成功入选重庆市科技型企业库，技术实力获得官方认可',
      icon: Award,
      color: 'from-red-600 to-orange-400',
    },
    {
      year: '2021',
      title: '高新技术企业',
      description: '获得国家高新技术企业认证，迈入行业领先行列',
      icon: Award,
      color: 'from-yellow-600 to-orange-400',
    },
    {
      year: '2023',
      title: 'AI技术研究院',
      description: 'AI技术研究院正式成立，布局人工智能与大数据领域',
      icon: Lightbulb,
      color: 'from-orange-500 to-red-500',
    },
  ];

  return (
    <section id="history" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <div className="inline-block px-4 py-1 rounded-full bg-orange-50 text-orange-600 text-sm mb-4">
            发展历程
          </div>
          <h2 className="text-gray-900 mb-4 px-4">成长的每一步</h2>
          <p className="text-gray-600 max-w-2xl mx-auto px-4">
            从创立至今，我们始终专注于技术创新与服务品质
          </p>
        </motion.div>

        <div className="relative">
          {/* Timeline Line */}
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-gradient-to-b from-yellow-500 via-orange-500 to-red-500"></div>

          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`relative flex flex-col lg:flex-row gap-8 items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Content */}
                <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                  <div className={`inline-block p-6 rounded-2xl bg-gradient-to-br ${milestone.color} text-white shadow-xl lg:max-w-md`}>
                    <div className="flex items-center space-x-3 mb-3">
                      <milestone.icon size={24} />
                      <div className="text-2xl">{milestone.year}</div>
                    </div>
                    <h4 className="text-white mb-2">{milestone.title}</h4>
                    <p className="text-white/90 text-sm">{milestone.description}</p>
                  </div>
                </div>

                {/* Center Icon */}
                <div className="relative flex-shrink-0">
                  <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${milestone.color} flex items-center justify-center shadow-lg border-4 border-white`}>
                    <Calendar className="text-white" size={28} />
                  </div>
                </div>

                {/* Spacer */}
                <div className="flex-1 hidden lg:block"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}